module.exports = __webpack_public_path__ + "static/media/El_mall_en_tu_celular.5b11a28f.svg";